<template>
  <div>
    <v-col class="pa=3 ma=5">
      <v-row no-gutters justify="end">
        <v-btn large color="primary" elevation="2" v-on:click="downloadResults"
          >Download</v-btn
        >
      </v-row>
    </v-col>
    <v-form class="text-right">
      <v-row class="ma=3 pa=3">
        <v-select
          v-model="filters.year.value"
          :items="recordYears"
          filled
          label="Year:"
          clearable
          multiple
        ></v-select>

        <v-select
          v-model="filters.station.value"
          :items="recordStation"
          item-value="station"
          filled
          label="Station:"
          clearable
          multiple
        ></v-select>
        <v-select
          v-model="filters.visit_date.value"
          :items="recordVisitDate"
          item-value="visit_date"
          filled
          label="Vist Date:"
          clearable
          multiple
        ></v-select>
      </v-row>
      <v-container>
        <v-row>
          Active Filters:
          <div>
            <v-chip-group column>
              <div v-for="key in Object.keys(filters)" :key="key">
                <v-chip
                  v-for="value in filters[key].value"
                  :key="value"
                  class="ma-2"
                  closable
                  @click:close="removeFilter(key, value)"
                >
                  {{ value }}
                </v-chip>
              </div>
            </v-chip-group>
          </div>
        </v-row>
      </v-container>
      <v-container class="text-center">
        <v-row>
          Hidden Columns:
          <div class="ma=6">
            <v-chip-group column>
              <v-chip
                v-for="value in filteredKeys"
                :key="value"
                class="ma-2"
                closable
                @click:close="addColumn(value)"
              >
                {{ value }}
              </v-chip>
            </v-chip-group>
          </div>
        </v-row>
      </v-container>
    </v-form>
    <v-data-table
      :headers="headers"
      :items="items"
      density="compact"
      :items-per-page="itemsPerPage"
    >
      <template v-slot:headers="{ columns, isSorted, getSortIcon, toggleSort }">
        <tr>
          <template v-for="column in columns" :key="column.key">
            <td>
              <span
                class="mr-2 cursor-pointer"
                @click="() => toggleSort(column)"
                >{{ column.title }}</span
              >
              <template v-if="isSorted(column)">
                <v-icon :icon="getSortIcon(column)"></v-icon>
              </template>
              <v-icon
                icon="$close"
                @click="() => removeColumn(column.key)"
              ></v-icon>
            </td>
          </template>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import data from "../plugins/data";
import support from "../plugins/support";
export default {
  name: "StationLog",

  data() {
    return {
      selected: "",
      itemsPerPage: 100,
      filteredKeys: ["gear", "net", "temperature_c", "investigators"],
      filters: {
        year: { value: [new Date().getFullYear()], field: "year" },
        station: { value: [], field: "station" },
        visit_date: { value: [], field: "visit_date" },
      },
    };
  },
  components: {},
  computed: {
    records() {
      const raw = this.$store.getters.viewData("sample_query");
      const groups = {};
      const seenSets = {};

      raw.forEach((row) => {
        const groupKey = `${row.station}__${row.visit_date}`;
        if (!groups[groupKey]) {
          groups[groupKey] = {
            station: row.station,
            visit_date: row.visit_date,
            investigators: row.investigators,
            temperature_c: row.temperature_c,
            gear: row.gear,
            set_count: row.gear,
            total_fish: 0,
          };
          seenSets[groupKey] = new Set();
        }
        const group = groups[groupKey];
        if (row.net != null && !seenSets[groupKey].has(row.net)) {
          seenSets[groupKey].add(row.net);
          group.set_count += 1;
        }
        if (row.field_species) {
          group[row.field_species] = (group[row.field_species] || 0) + 1;
          group.total_fish += 1;
        }
      });

      return Object.values(groups);
    },
    items() {
      return this.records.filter((item) => this.itemPasses(item));
    },
    fields() {
      const siteQueryKeys = new Set(
        data.tableFields["site_query"].map((f) => f.key),
      );
      const speciesSet = new Set();
      this.items.forEach((item) => {
        Object.keys(item).forEach((k) => {
          if (!siteQueryKeys.has(k) && item[k]) speciesSet.add(k);
        });
      });
      const speciesFields = Array.from(speciesSet)
        .sort()
        .map((species) => ({ key: species, title: species }));
      return [...data.tableFields["site_query"], ...speciesFields];
    },
    recordYears() {
      // Generate years from 1997 to current year instead of deriving from loaded data
      const currentYear = new Date().getFullYear();
      const startYear = 1997;
      const years = [];
      for (let year = currentYear; year >= startYear; year--) {
        years.push(year);
      }
      return years;
    },

    recordStation() {
      return Array.from(new Set(this.records.map((item) => item.station)));
    },
    recordVisitDate() {
      return Array.from(new Set(this.records.map((item) => item.visit_date))).sort().reverse();
    },
    headers() {
      return this.fields.filter(
        (header) => !this.filteredKeys.includes(header.key),
      );
    },
  },
  watch: {
    'filters.year.value': function(newYears) {
      // When year filter changes, load data for those years if not already loaded
      const loadedYears = this.$store.state.loadedYears["sample_query"] || [];
      const yearsToLoad = [];
      
      for (const year of newYears) {
        if (!loadedYears.includes(year)) {
          yearsToLoad.push(year);
        }
      }
      
      // Load missing years in parallel
      if (yearsToLoad.length > 0) {
        yearsToLoad.forEach(year => {
          support.getApiData("views", "sample_query", `/sample_query/year/${year}/`)
            .catch(err => console.error(`Failed to load year ${year}:`, err));
        });
      }
    }
  },
  methods: {
    itemPasses(item) {
      let arr = Object.values(this.filters).map((fil) => {
        if (fil.field === "year") {
          return (
            Object.values(fil.value).includes(
              new Date(item.visit_date).getFullYear(),
            ) || fil.value.length <= 0
          );
        }
        if (fil.field === "visit_date") {
          return (
            Object.values(fil.value).includes(item.visit_date) ||
            fil.value.length <= 0
          );
        } else {
          return (
            Object.values(fil.value).includes(item[fil.field]) ||
            fil.value.length <= 0
          );
        }
      });

      return arr.every((v) => v === true);
      //   (Object.values(this.filters.year.value).includes((new Date(item.visit_date)).getFullYear()) || this.filter.year.value.length <= 0) &&
      //   Object.values(this.filters).forEach((fil) => (Object.values(fil.value)).includes(item[fil.field]) || fil.value.length <=  0);
    },
    removeColumn(key) {
      this.filteredKeys.push(key);
      //this.headers = this.headers.filter(header => header.key !== key)
    },
    addColumn(key) {
      const index = this.filteredKeys.indexOf(key);
      if (index > -1) {
        // only splice array when item is found
        this.filteredKeys.splice(index, 1); // 2nd parameter means remove one item only
      }
    },
    removeFilter(key, value) {
      const index = this.filters[key].value.indexOf(value);
      if (index > -1) {
        // only splice array when item is found
        this.filters[key].value.splice(index, 1); // 2nd parameter means remove one item only
      }
    },
    downloadResults() {
      let csvData = this.$papa.unparse(this.items, {
        columns: this.headers.map((field) => field.key),
      });
      const d = new Date();
      const ts = `${d.getUTCFullYear()}-${(d.getUTCMonth() + 1)
        .toString()
        .padStart(2, "0")}-${d.getUTCDate().toString().padStart(2, "0")}`;
      this.$papa.download(csvData, `ydfda_${ts}`);
    },
  },
};
</script>
